<template>
	<q-modal
		v-model="show"
		:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		no-backdrop-dismiss
		no-esc-dismiss
	>
		<q-modal-layout>
			<q-toolbar slot="header">
				<q-btn flat round dense @click="show = false" icon="fas fa-times" />
				<q-toolbar-title>
					{{ title }}
				</q-toolbar-title>
			</q-toolbar>
			<div class="layout-padding">
				<q-list separator highlight>
					<template v-for="(answer, index) in answers">
						<q-item :key="index" v-if="!answer.justification">
							<q-item-main
								:label="`${answer.user_full_name} - ${answer.user_email}`"
								label-lines="1"
								:sublabel="
									`${
										answer.answers.length > 1 ? $t('answers') : $t('answer')
									}: ${answer.answers.join(', ')}`
								"
								sublabel-lines="1"
							/>
						</q-item>

						<q-collapsible
							v-if="answer.justification"
							:label="`${answer.user_full_name} - ${answer.user_email}`"
							label-lines="1"
							:sublabel="
								`${
									answer.answers.length > 1 ? $t('answers') : $t('answer')
								}: ${answer.answers.join(', ')}`
							"
							sublabel-lines="1"
						>
							<div class="text-faded">
								{{ $t('justification') }}:
								{{ answer.justification }}
							</div>
						</q-collapsible>
					</template>
				</q-list>
				<div class="row justify-center">
					<q-pagination
						input
						v-model="page"
						:min="minPages"
						:max="maxPages"
						@input="fetchData"
					/>
				</div>
			</div>
		</q-modal-layout>
	</q-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: ['question', 'show_question', 'id', 'title'],

	data() {
		return {
			answers: [],
			page: 1,
			minPages: 1,
			maxPages: 0,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		show: {
			get() {
				return this.show_question
			},
			set() {
				this.$emit('hide_user_answers', '')
			},
		},
	},

	methods: {
		fetchData() {
			const PAGE_SIZE = 10
			this.$q.loading.show()

			let data = {
				page_size: PAGE_SIZE,
				page: this.page,
			}

			this.$axios
				.get(
					`/admin_surveys/surveys/${this.id}/survey_report_questions_users/${
						this.question.id
					}/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.answers = response.data.results
					this.maxPages = Math.ceil(response.data.count / PAGE_SIZE)
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},
	},

	watch: {
		show_question: function() {
			if (this.show_question) {
				this.fetchData()
			}
		},
	},
}
</script>

<style></style>
